<organization-select
  #orgManager
  autoSelectFirst="true"
  class="mr-3"
></organization-select>

<site-select
  #siteManager
  [org]="orgManager?.currentValue"
  autoSelectFirst="true"
  class="mr-3"
  (change)="setSite($event)"
></site-select>
<br />

<button class="btn btn-outline-secondary mb-4" (click)="deviceStatus()">
  Stato Dispositivi
</button>

<custom-radio
  #radioManager
  [values]="dashboardFilters"
  [selected]="dashboardFilters[2]"
  title_multiple="radio.dashboard.label"
  (change)="setFilter($event)"
>
</custom-radio>

<br />

<help-alert
  text="help.page.dashboard.field"
  info="help.info"
  description="help.page.dashboard.description"
>
</help-alert>

<br />
<br />

<custom-table
  #siteTable
  table_id="siteTable"
  title_single="tables.dashboard.sites.title"
  title_multiple="tables.dashboard.sites.title"
  filter_title="tables.dashboard.sites.filter_title"
  no_filter_row="true"
  [columns]="siteColumns"
  [values]="sitesData"
  reloadable="true"
  (refresh)="getDashboard('SI')"
></custom-table>
<!--
                        <custom-table           #siteTable
                        table_id            =   "siteTable"
                        title_single        =   "tables.dashboard.sites.title"
                        title_multiple      =   "tables.dashboard.sites.title"
                        filter_title        =   "tables.dashboard.sites.filter_title"
                        no_filter_row       =   "true"
                        [columns]           =   "siteColumns"
                        [values]            =   "sitesData"
                        reloadable          =   "true"
                        (refresh)           =   "getDashboard('SI')"
                        [chartsConf]        =   "chartsConf"></custom-table> -->

<br />
<br />

<custom-table
  #serviceTable
  table_id="serviceTable"
  title_single="tables.dashboard.services.title"
  title_multiple="tables.dashboard.services.title"
  filter_title="tables.dashboard.services.filter_title"
  no_filter_row="true"
  [columns]="servicesColumns"
  [values]="servicesData"
  reloadable="true"
  (refresh)="getDashboard('SE')"
></custom-table>

<!-- <custom-table           #serviceTable
                        table_id            =   "serviceTable"
                        title_single        =   "tables.dashboard.services.title"
                        title_multiple      =   "tables.dashboard.services.title"
                        filter_title        =   "tables.dashboard.services.filter_title"
                        no_filter_row       =   "true"
                        [columns]           =   "servicesColumns"
                        [values]            =   "servicesData"
                        reloadable          =   "true"
                        (refresh)           =   "getDashboard('SE')"
                        [chartsConf]        =   "chartsConf_service"></custom-table> -->

<br />
<br />

<custom-table
  #deviceTable
  table_id="deviceTable"
  title_single="tables.dashboard.counters.title"
  title_multiple="tables.dashboard.counters.title"
  filter_title="tables.dashboard.counters.filter_title"
  no_filter_row="true"
  [columns]="countersColumns"
  [values]="countersData"
  reloadable="true"
  (refresh)="getDashboard('DE')"
></custom-table>

<!--
                        <custom-table           #deviceTable
                        table_id            =   "deviceTable"
                        title_single        =   "tables.dashboard.counters.title"
                        title_multiple      =   "tables.dashboard.counters.title"
                        filter_title        =   "tables.dashboard.counters.filter_title"
                        no_filter_row       =   "true"
                        [columns]           =   "countersColumns"
                        [values]            =   "countersData"
                        reloadable          =   "true"
                        (refresh)           =   "getDashboard('DE')"
                        [chartsConf]        =   "chartsConf_device"></custom-table> -->
